/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useLocale } from '@/hooks/useLocale';
import styles from './Price.module.scss';
import { getCurrencySymbol } from '@/utils/priceHelpers';

type Props = {
  dealPrice?: string[] | null;
  wasDealPrice?: string[] | null;
  tabIndex?: number;
};

export const StrikethroughPrice = ({ dealPrice, wasDealPrice, tabIndex }: Props) => {
  const locale = useLocale();
  const currencySymbol = getCurrencySymbol(locale);

  const displayStrikethroughPrice =
    wasDealPrice &&
    dealPrice &&
    (wasDealPrice[0] !== dealPrice[0] || wasDealPrice[1] !== dealPrice[1]);

  if (!displayStrikethroughPrice) {
    return null;
  }

  return (
    <div className={styles.strikethroughPrice} tabIndex={tabIndex}>
      {currencySymbol}
      {wasDealPrice[0]}.{wasDealPrice[1]}
    </div>
  );
};

export default StrikethroughPrice;
